<template>
  <!-- v-on:touchmove="dragStart($event)" -->
  <div
    class="card"
    v-on:touchmove="dragStart($event)"
    :style="{ width: sizeBox.width + 'px', height: sizeBox.height + 'px' }"
  >
    <img
      :src="prizeCurtain"
      id="front-image"
      @load="loadedImage"
      v-show="false"
      class="front-image"
      ref="frontImage"
      alt=""
    />
    <div class="result" v-show="scratchPrizeShow">
      <slot></slot>
    </div>
    <canvas
      v-show="showCanvas"
      class="card-box"
      ref="card"
      :style="bg_img"
      :width="c_width"
      :height="c_height"
    >
    </canvas>
  </div>
</template>
<script>
import prizeCurtain from '@/assets/imgs/activitys/guaguaka-weigua.png'
export default {
  data() {
    return {
      designWight: 375,
      card_canvas: '',
      scratchPrizeShow: false,
      scratch_status: true,
      bg_img: '',
      prizeCurtain: prizeCurtain,
      showCanvas: true,
      imageLoaded: false
    }
  },
  name: 'ScratchCard',
  props: {
    c_width: {
      default: 300 //宽度
    },
    c_height: {
      default: 200 //高度
    },
    cricle_size: {
      default: 10 //刮圆的大小
    },
    percent: {
      default: 60 //刮去百分比
    },
    c_color: {
      default: '#c3c3c3' //遮盖层颜色
    },
    showResult: {
      default: false //是否直接显示结果
    },
    speed: {
      type: Number,
      default: 10 //划线速度
    },
    allow: {
      default: true //是否允许用户刮开
    }
  },
  computed: {
    sizeBox() {
      return {
        width: (this.c_width * window.screen.width) / this.designWight,
        height: (this.c_height * window.screen.width) / this.designWight
      }
    }
  },
  created() {
    this.showCanvas = !this.showResult
  },
  mounted: function () {
    this.getCanvasDom()
  },
  methods: {
    init() {
      this.getCanvasDom()
    },
    getCanvasDom() {
      this.card_canvas = this.$refs.card.getContext('2d', {
        willReadFrequently: true
      })
      this.card_canvas.globalCompositeOperation = 'source-over'
      this.card_canvas.fillStyle = this.c_color
      this.card_canvas.fillRect(0, 0, this.c_width, this.c_height)
    },
    loadedImage() {
      this.imageLoaded = true
      const img = document.getElementById('front-image')
      this.card_canvas.drawImage(img, 0, 0, this.c_width, this.c_height)
      this.scratchPrizeShow = true
      //this.drawText();
      if (!this.allow && this.needAuto) {
        this.auto()
      }
    },
    async auto() {
      this.needAuto = true
      if (this.imageLoaded) {
        this.drawLine()
      }
    },
    drawText() {
      /* 中奖啦去查看 */
      // 计算文本的宽度和高度
      const text = '中奖啦，去查看'
      const fontSize = 20
      this.card_canvas.font = `${fontSize}px Arial`
      const textMetrics = this.card_canvas.measureText(text)
      const textWidth = textMetrics.width
      const textHeight = fontSize

      // 计算水平和垂直居中的坐标
      const x = (this.c_width - textWidth) / 2
      const y = (this.c_height - textHeight) / 2 + fontSize

      // 绘制文本
      this.card_canvas.fillStyle = 'black'
      this.card_canvas.fillText(text, x, y)
    },
    /* 画断断续续的线 */
    drawLine() {
      let res = []
      /* 二维数组 起始点和终点 */
      //let points = [[{ x: 170, y: 50 }, { x: 50, y: 180 }],[{ x: 230, y: 50 }, { x: 110, y: 190 }]];
      let points = [
        [
          { x: 140, y: 0 },
          { x: 0, y: 140 }
        ],
        [
          { x: 0, y: 190 },
          { x: 270, y: 0 }
        ],
        [
          { x: 320, y: 10 },
          { x: 70, y: 220 }
        ],
        [
          { x: 160, y: 220 },
          { x: 310, y: 90 }
        ]
      ]
      for (let i = 0; i < points.length; i++) {
        let item = points[i]
        let beforeItem = item[0]
        let lastItem = item[1]
        let list = this.getPointsBetweenTwoPoints(
          beforeItem.x,
          beforeItem.y,
          lastItem.x,
          lastItem.y
        )
        res = res.concat(list)
      }
      let speed = 50 / this.speed
      res.map((item, index) => {
        setTimeout(() => {
          this.dragByPoint(item.x, item.y)
          if (index >= res.length - 1) {
            setTimeout(() => {
              this.autoDragEnd()
            }, 100)
          }
        }, speed * index)
      })
    },
    autoDragEnd() {
      this.card_canvas.beginPath()
      this.card_canvas.globalCompositeOperation = 'destination-out'
      this.card_canvas.fillRect(0, 0, this.c_width, this.c_height)
      this.scratch_status = false
      this.SuccessFunc()
    },
    getPointsBetweenTwoPoints(x1, y1, x2, y2) {
      const points = []
      const distanceX = x2 - x1
      const distanceY = y2 - y1
      const totalDistance = Math.sqrt(
        distanceX * distanceX + distanceY * distanceY
      )
      const numPoints = Math.ceil(totalDistance)

      for (let i = 0; i <= numPoints; i++) {
        const t = i / numPoints
        const x = x1 + t * distanceX
        const y = y1 + t * distanceY
        points.push({ x: x, y: y })
      }

      return points
    },
    /* 通过x,y点擦除遮罩 */
    dragByPoint(x, y) {
      this.card_canvas.beginPath()
      this.card_canvas.globalCompositeOperation = 'destination-out'
      this.card_canvas.arc(x - 10, y - 10, this.cricle_size, 0, Math.PI * 2)
      this.card_canvas.fill()
    },
    dragStart($event) {
      /* 已刮开或者自动刮时禁止 */
      if (!this.scratch_status || !this.allow) {
        return
      }
      let rect = $event.currentTarget.getBoundingClientRect()
      let x = $event.changedTouches[0].clientX - rect.left
      let y = $event.changedTouches[0].clientY - rect.top
      this.card_canvas.beginPath()
      this.card_canvas.globalCompositeOperation = 'destination-out'
      this.card_canvas.arc(x - 10, y - 10, this.cricle_size, 0, Math.PI * 2)
      this.card_canvas.fill()
      if (this.percent <= this.getPercent()) {
        this.card_canvas.beginPath()
        this.card_canvas.globalCompositeOperation = 'destination-out'
        this.card_canvas.fillRect(0, 0, this.c_width, this.c_height)
        this.scratch_status = false
        this.SuccessFunc()
      }
    },
    getPercent() {
      var _thisCtx = this.card_canvas.getImageData(
          0,
          0,
          this.c_width,
          this.c_height
        ),
        _data = _thisCtx.data,
        _pixArr = 0,
        _dataLen = _data.length
      for (var i = 0; i < _dataLen; i += 4) {
        if (_data[i + 3] < 128) {
          _pixArr++
        }
      }
      return parseFloat((_pixArr / (_dataLen / 4)) * 100)
    },
    SuccessFunc() {
      this.showCanvas = false
      this.$emit('SuccessFunc')
    }
  }
}
</script>
<style scoped lang="scss">
.card {
  display: inline-block;
  position: relative;
  .result {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  .front-image {
    z-index: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .finger {
    width: 50px;
    height: 50px;
    position: absolute;
    z-index: 3;
  }
  .card-box {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 2;
  }
}
</style>
